import useTheme from 'branding/theme';
import getLowerStrength from './getLowerStrength';
const useSubtheme = (config) => {
    const { colors } = useTheme();
    if (config[0] === 'regular') {
        return {
            borderColor: config[1] === 'transparent'
                ? colors.neutrals.borderBeta
                : colors.brand.primary.alpha,
            backgroundColor: config[1] === 'transparent' || config[1] === 'background'
                ? colors.neutrals[config[1]]
                : colors.brand.primary.alpha
        };
    }
    // TS-induced damage, otherwise would work without this `if` branch
    if (config[0] === 'status') {
        return {
            borderColor: colors[config[0]][config[1]][config[2]],
            backgroundColor: colors[config[0]][config[1]][getLowerStrength(config[2])]
        };
    }
    return {
        borderColor: colors[config[0]][config[1]][config[2]],
        backgroundColor: colors[config[0]][config[1]][getLowerStrength(config[2])]
    };
};
export default useSubtheme;
//# sourceMappingURL=index.js.map